/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Cta_MacosInputs */

const en_home_hero_cta_macos = /** @type {(inputs: Home_Hero_Cta_MacosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download for macOS`)
};

/**
* | output |
* | --- |
* | "Download for macOS" |
*
* @param {Home_Hero_Cta_MacosInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_hero_cta_macos = /** @type {((inputs?: Home_Hero_Cta_MacosInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Cta_MacosInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_hero_cta_macos(inputs)
});
export { home_hero_cta_macos as "home.hero.cta_macos" }